import IComponent from "components/commons/IComponent";
import "./RainfallTool.scoped.css";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { IconButton } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";

import MiniPanel from "components/commons/MiniPanel";
import SwitchButton from "components/commons/SwitchButton";
import OpacitySlider from "components/LayerSetting/OpacitySlider";

import MediaLayer from "@arcgis/core/layers/MediaLayer.js";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";

import ImageElement from "@arcgis/core/layers/support/ImageElement.js";
import ExtentAndRotationGeoreference from "@arcgis/core/layers/support/ExtentAndRotationGeoreference.js";
import Extent from "@arcgis/core/geometry/Extent.js";

import React from "react";
import IdentifyManager from "components/MapViews/IdentifyManager";
import RainfallChart from "components/RainfallTool/RainfallChart";
import ReactDOM from "react-dom/client";

const initRainfall = "oneHour";
class RainfallTool extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      rainfallContourSwitchCheck: false,
      rainfallTitle: initRainfall,
      rainfallLastUpdate: "N/A",

      raingaugeSwitchCheck: false,
    };
  }
  componentDidMount() {
    console.log(this.props);
    const rainfallLayer = this.props.mapView.map.findLayerById("rainfallLayer");
    const raingaugeLayer = this.props.mapView.map.findLayerById(
      "raingaugeLayer"
    );

    if (rainfallLayer) {
      this.setState({
        rainfallContourSwitchCheck: true,
        rainfallTitle: rainfallLayer.title,
      });
    }

    if (raingaugeLayer) {
      this.setState({
        raingaugeSwitchCheck: true,
      });
    }

    this.makeHttpQuery(this.$config.rainfallLastUpdate, "GET").then((e) => {
      this.setState({
        rainfallLastUpdate: e,
      });
    });
  }

  componentDidUpdate(prevProp, prevState) {
    //   console.log(prevState, this.state)
    //   if(this.state)
  }
  componentWillUnmount() {}

  handleChangeRailfallValue(e) {
    console.log("radio change");
    const rainfallLayer = this.props.mapView.map.findLayerById("rainfallLayer");
    this.props.mapView.map.remove(rainfallLayer);

    const imageEle = new ImageElement({
      image: this.$config.twenty4HourRainfall,
      georeference: new ExtentAndRotationGeoreference({
        extent: new Extent({
          spatialReference: {
            latestWkid: 2326,
            wkid: 102140,
          },
          xmin: 800000,
          ymin: 800000,
          xmax: 864000,
          ymax: 848000,
        }),
      }),
    });
    switch (e.target.value) {
      case "twenty4Hour":
        break;
      case "oneHour":
        imageEle.image = this.$config.oneHourRainfall;
        break;
      default:
        break;
    }

    const mediaLayer = new MediaLayer({
      opacity: 0.8,
      source: [imageEle],
      id: "rainfallLayer",
      listMode: "hide",
      title: e.target.value,
    });

    const onLayerCreate = this.props.mapView.on("layerview-create", (obj) => {
      if (obj.layer === mediaLayer) {
        console.log("medialayer created", obj.layer);
        this.setState({ rainfallTitle: e.target.value });
        onLayerCreate.remove();
      }
    });

    this.props.mapView.map.add(mediaLayer);
  }

  handleClickShowRainfallContour() {
    if (!this.state.rainfallContourSwitchCheck) {
      const imageEle = new ImageElement({
        image: this.$config[`${this.state.rainfallTitle}Rainfall`],
        georeference: new ExtentAndRotationGeoreference({
          extent: new Extent({
            spatialReference: {
              latestWkid: 2326,
              wkid: 102140,
            },
            xmin: 800000,
            ymin: 800000,
            xmax: 864000,
            ymax: 848000,
          }),
        }),
      });
      const mediaLayer = new MediaLayer({
        opacity: 0.8,
        source: [imageEle],
        id: "rainfallLayer",
        listMode: "hide",
        title: initRainfall,
      });
      const onLayerCreate = this.props.mapView.on("layerview-create", (obj) => {
        if (obj.layer === mediaLayer) {
          this.setState({
            rainfallContourSwitchCheck: true,
          });
          onLayerCreate.remove();
        }
      });

      this.props.mapView.map.add(mediaLayer);
    } else {
      const rainfallLayer = this.props.mapView.map.findLayerById(
        "rainfallLayer"
      );
      this.props.mapView.map.remove(rainfallLayer);
      this.setState({
        rainfallContourSwitchCheck: false,
      });
    }
  }

  handleClickShowRaingauge() {
    if (!this.state.raingaugeSwitchCheck) {
      this.props.showDialog({
        isOpen: true,
        title: "Adding layer...",
        content: (
          <div>
            <span className="icn_loading" />
            Adding the Raingauge map layer to the map, please wait...
          </div>
        ),
      });
      const raingaugeLayer = new FeatureLayer({
        url: this.$config.raingaugeLayer,
        id: "raingaugeLayer",
        listMode: "hide",
      });

      const onLayerCreate = this.props.mapView.on("layerview-create", (obj) => {
        if (obj.layer === raingaugeLayer) {
          this.setState({
            raingaugeSwitchCheck: true,
          });
          raingaugeLayer.popupTemplate = raingaugeLayer.createPopupTemplate();
          onLayerCreate.remove();
          this.props.showDialog({
            isOpen: false,
          });
          IdentifyManager.addPopupTemplate(raingaugeLayer.title, {
            title: "Rain Gauge: {No}",
            content: function(feature) {
              let graphic, attributes, content;
              graphic = feature.graphic;
              attributes = graphic.attributes;
              content = document.createElement("DIV");
              content.style.height = "100%";
              let root = ReactDOM.createRoot(content);
              setTimeout(() => {
                root.render(<RainfallChart raingauge={attributes.No} />);
              });
              return content;
            },
          });
        }
      });

      this.props.mapView.map.add(raingaugeLayer);
    } else {
      const rainfallLayer = this.props.mapView.map.findLayerById(
        "raingaugeLayer"
      );
      this.props.mapView.map.remove(rainfallLayer);
      this.setState({
        raingaugeSwitchCheck: false,
      });
    }
  }

  render() {
    const rainfallLayer = this.props.mapView.map.findLayerById("rainfallLayer");
    return (
      <div className="RainfallContainer" style={{ width: "500px" }}>
        <div className="PanelTitle">
          <span>Real Time Rainfall</span>
        </div>
        <div className="SubPanelContent">
          <MiniPanel
            collapsed={!this.state.rainfallContourSwitchCheck}
            titleText={
              <SwitchButton
                label={"Show Rainfall Contour"}
                placeAtRight={true}
                // checked={lyrDataObj.layer?.visible}
                checked={this.state.rainfallContourSwitchCheck}
                onClick={this.handleClickShowRainfallContour.bind(this)}
              />
            }
          >
            <div className="SubPanelContent">
              <RadioGroup
                row
                aria-label="quiz"
                name="quiz"
                value={this.state.rainfallTitle}
                onChange={this.handleChangeRailfallValue.bind(this)}
              >
                <FormControlLabel
                  value="oneHour"
                  control={<Radio />}
                  label="1-Hour"
                />
                <FormControlLabel
                  value="twenty4Hour"
                  control={<Radio />}
                  label="24-Hour"
                />
              </RadioGroup>
              <OpacitySlider layer={rainfallLayer} />
              <div>
                Last Update : {this.state.rainfallLastUpdate}
                <IconButton
                  onClick={() => {
                    this.makeHttpQuery(
                      this.$config.rainfallLastUpdate,
                      "GET"
                    ).then((e) => {
                      this.setState({
                        rainfallLastUpdate: e,
                      });
                    });
                  }}
                >
                  <Refresh />
                </IconButton>
              </div>
            </div>
          </MiniPanel>
        </div>
        <div className="SubPanelContent">
          <MiniPanel
            collapsed={true}
            titleText={
              <SwitchButton
                label={"Show Raingauge"}
                placeAtRight={true}
                // checked={lyrDataObj.layer?.visible}
                checked={this.state.raingaugeSwitchCheck}
                onClick={this.handleClickShowRaingauge.bind(this)}
              />
            }
          />
        </div>
        <div />
      </div>
    );
  }
}

export default RainfallTool;
